import {
  AloftPrice,
  PairedCostAdjustmentType,
  PairedCostResults,
  isDefined,
} from '@aloft/toolkit-shared';

export function hasAdjustments(
  results: PairedCostResults,
  adjustmentType: PairedCostAdjustmentType,
) {
  const comps = Object.values(results.comps).map((comp) => comp.adjustments?.[adjustmentType]);

  return Object.values(comps).some(
    (comp) => isDefined(comp?.adjustment) && !comp?.adjustment.equals(AloftPrice.zero),
  );
}
